import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api';

import { apiQuery } from '../../query';

import { ContactUsPayload } from './types';

const tagTypes = ['CONTACT_US'];

export const contactUsApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'contactUsApi',
  endpoints: (build) => ({
    submitContactUs: build.mutation<void, ContactUsPayload>({
      query: (data) => ({
        data,
        method: 'post',
        url: URL.CONTACT_US,
      }),
    }),
  }),
});

export const { useSubmitContactUsMutation } = contactUsApi;
